import { useTheme } from '@emotion/react';
import { Stack, Switch, Typography } from '@mui/material';
import React from 'react';
import { allowEUATrading, setCompanyDetails, toggleError } from '../../../../redux/features/authSlice';
import { useDispatch, useSelector } from 'react-redux';
import { showmessage } from '../../../../utils/toastr';
import { setLoading } from '../../../../redux/features/appSlice';
import appapi from '../../../../api/apiClient';
import { useTranslation } from 'react-i18next';
import moment from 'moment-timezone';

export default function BuyOrSell() {
  const theme = useTheme();
  const dispatch = useDispatch();
  const text = theme.palette.primary.text;
  const textLight = theme.palette.primary.textLight;

  const { t } = useTranslation();

  const { companyDetails } = useSelector((state) => state.auth);
  const allowTrading = useSelector((state) => allowEUATrading(state.auth.companyDetails));

  const handleOnChange = (e) => {
    if (e.target.checked) {
      if (!allowTrading) {
        updateEUATradingStatus(1);
      } else {
        dispatch(setCompanyDetails({ ...companyDetails, euaTrading: false }));
        dispatch(toggleError(true));
        showmessage(`Please add ${allowTrading} before trading.`, 'error');
      }
    } else {
      updateEUATradingStatus(0);
    }
  };

  const updateEUATradingStatus = async (status) => {
    dispatch(setLoading(true));
    const response = await appapi.put(`/company-management/euaTrading/${companyDetails?._id}/${status}`, {
      timeZone: moment.tz.guess(true),
    });
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        dispatch(setCompanyDetails({ ...companyDetails, euaTrading: status === 1 ? true : false }));
        dispatch(setLoading(false));
        // showmessage(data.message, 'success');
      } else {
        dispatch(setCompanyDetails({ ...companyDetails, euaTrading: false }));
        showmessage(data.message, 'error');
        dispatch(setLoading(false));
      }
    } else {
      dispatch(setLoading(false));
      showmessage(`Something Went Wrong!`, 'error', 2000);
    }
  };

  return (
    <Stack style={{ backgroundColor: '#F2F3F580', borderRadius: '8px', padding: '16px', borderColor: '#8993AC26', borderWidth: '1px' }}>
      <Stack
        direction={'row'}
        alignItems={'center'}
        justifyContent={'space-between'}
      >
        <Typography
          className="fs-14 ff-Roboto fw-medium"
          color={text}
        >
          {t('Do you want to buy or sell?')}
        </Typography>
        <Stack
          direction={'row'}
          alignItems={'center'}
        >
          <Switch
            checked={companyDetails?.euaTrading}
            onChange={handleOnChange}
            inputProps={{ 'aria-label': 'controlled' }}
          />
          <Typography
            className="fs-14 ff-Roboto fw-medium"
            color={text}
          >
            {companyDetails?.euaTrading ? t('Yes') : t('No')}
          </Typography>
        </Stack>
      </Stack>
      <Typography
        className="fs-12 ff-Roboto fw-regular !mt-[10px]"
        color={textLight}
        style={{ maxWidth: '450px' }}
      >
        {t('This platform allows users to trade allowances with verified traders on the platform')}. {t('To start trading, please provide required documents and information')}.
      </Typography>
    </Stack>
  );
}
